<div class="float-btn-wrapper">
    <button class="float-btn quick-action-btn" (click)="openWizard()">Quick<br>Action</button>
</div>
